import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { InspectionPluginService } from '../../shared/services/index';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './edit-json.component.html',
    standalone: false
})
export class PluginEditJsonPageComponent extends BaseModalPageComponent implements OnInit {
  public plugin: any;
  public pluginId: string;
  public inspectionId: string;
  public pointId: string;
  public processing = false;

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pluginService: InspectionPluginService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId, 'points', this.pointId]);

      this.pluginId = pluginId;

      this.initData();
    });
  }

  initData(): void {
    this.pluginService.getPluginEntity(this.inspectionId, this.pointId, this.pluginId).subscribe((data) => {
      this.plugin = data;
    });
  }

  savePlugin(point: any): void {
    this.processing = true;
    this.pluginService.updatePluginEntity(this.inspectionId, this.pointId, this.pluginId, point).subscribe((res) => {
      this.goToBack();
    });
  }

  cancel(): void {
    this.goToBack();
  }
}
